import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Uso_suelo } from 'src/app/models/uso_de_suelo.model';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-uso-de-suelo',
  templateUrl: './uso-de-suelo.component.html',
  styleUrls: ['./uso-de-suelo.component.css']
})
export class UsoDeSueloComponent {
  public rows = [];
  public actualRow;
  public uso_suelo: Uso_suelo;
  public form;
  public num;
  public formulario;

  public form131 = false;

  public form111 = false;
  public form112 = false;
  public form113 = false;
  public form114 = false;

  public form211 = false;
  public form212 = false;
  public form213 = false;
  public form214 = false;

  public form231 = false;
  public form232 = false;
  public form233 = false;
  public form234 = false;
  public form235 = false;

  public form251;
  public form252;
  public form253;
  public form254;
  public form255;

  public matcher = new FormService();

  constructor() {
    this.formulario = localStorage.getItem("form")


    if (this.formulario == "1-3.1") {
      this.form131 = true
    }


    if (this.formulario == "1-1.1") {
      this.form111 = true
      this.num = '6.3'
    }
    if (this.formulario == "1-1.2") {
      this.form112 = true
        this.num = '6.3'
    }
    if (this.formulario == "1-1.3") {
      this.form113 = true
        this.num = '6.3'
    }
    if (this.formulario == "1-1.4") {
      this.form114 = true
        this.num = '6.3'
    }

    if (this.formulario == "2-1.1") {
      this.form211 = true
    }
    if (this.formulario == "2-1.2") {
      this.form212 = true
    }
    if (this.formulario == "2-1.3") {
      this.form213 = true
    }
    if (this.formulario == "2-1.4") {
      this.form214 = true
    }
    if (this.formulario == "2-3.1") {
      this.form231 = true;
    }
    if (this.formulario == "2-3.2") {
      this.form232 = true;
    }
    if (this.formulario == "2-3.3") {
      this.form233 = true;
    }
    if (this.formulario == "2-3.4") {
      this.form234 = true;
    }
    if (this.formulario == "2-3.5") {
      this.form235 = true;
    }

    if (this.formulario == "2-5.1") {
      this.form251 = true;
    }
    if (this.formulario == "2-5.2") {
      this.form252 = true;
    }
    if (this.formulario == "2-5.3") {
      this.form253 = true;
    }
    if (this.formulario == "2-5.4") {
      this.form254 = true;
    }
    if (this.formulario == "2-5.5") {
      this.form255 = true;
    }


    this.form = new FormGroup({
      destino_original: new FormControl(''),

      /* permiso original */
      clase_residencial: new FormControl(''),
      clase_equipamiento: new FormControl(''),
      clase_productivas: new FormControl(''),
      clase_infraestructura: new FormControl(''),
      clase_areaVerde: new FormControl(''),
      clase_espacioPublica: new FormControl(''),
      /* permiso */
      clase1_residencial: new FormControl(''),
      clase1_equipamiento: new FormControl(''),
      clase1_productivas: new FormControl(''),
      clase1_infraestructura: new FormControl(''),
      clase1_areaVerde: new FormControl(''),
      clase1_espacioPublica: new FormControl(''),
      /* modificacion */
      clase2_residencial: new FormControl(''),
      clase2_equipamiento: new FormControl(''),
      clase2_productivas: new FormControl(''),
      clase2_infraestructura: new FormControl(''),
      clase2_areaVerde: new FormControl(''),
      clase2_espacioPublica: new FormControl(''),

      actividad_equipamiento: new FormControl(''),
      actividad1_equipamiento: new FormControl(''),
      actividad2_equipamiento: new FormControl(''),

      escala_equipamiento: new FormControl(''),
      escala1_equipamiento: new FormControl(''),
      escala2_equipamiento: new FormControl(''),
    })

    if (!JSON.parse(localStorage.getItem("uso_suelo"))) {
      localStorage.setItem("uso_suelo", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("uso_suelo"));
      this.form.controls['destino_original'].setValue(this.rows[0] ? this.rows[0].destino_original : '')

      this.form.controls['clase_residencial'].setValue(this.rows[0] ? this.rows[0].clase_residencial : '')
      this.form.controls['clase_equipamiento'].setValue(this.rows[0] ? this.rows[0].clase_equipamiento : '')
      this.form.controls['clase_productivas'].setValue(this.rows[0] ? this.rows[0].clase_productivas : '')
      this.form.controls['clase_infraestructura'].setValue(this.rows[0] ? this.rows[0].clase_infraestructura : '')
      this.form.controls['clase_areaVerde'].setValue(this.rows[0] ? this.rows[0].clase_areaVerde : '')
      this.form.controls['clase_espacioPublica'].setValue(this.rows[0] ? this.rows[0].clase_espacioPublica : '')

      this.form.controls['clase1_residencial'].setValue(this.rows[0] ? this.rows[0].clase1_residencial : '')
      this.form.controls['clase1_equipamiento'].setValue(this.rows[0] ? this.rows[0].clase1_equipamiento : '')
      this.form.controls['clase1_productivas'].setValue(this.rows[0] ? this.rows[0].clase1_productivas : '')
      this.form.controls['clase1_infraestructura'].setValue(this.rows[0] ? this.rows[0].clase1_infraestructura : '')
      this.form.controls['clase1_areaVerde'].setValue(this.rows[0] ? this.rows[0].clase1_areaVerde : '')
      this.form.controls['clase1_espacioPublica'].setValue(this.rows[0] ? this.rows[0].clase1_espacioPublica : '')

      this.form.controls['clase2_residencial'].setValue(this.rows[0] ? this.rows[0].clase2_residencial : '')
      this.form.controls['clase2_equipamiento'].setValue(this.rows[0] ? this.rows[0].clase2_equipamiento : '')
      this.form.controls['clase2_productivas'].setValue(this.rows[0] ? this.rows[0].clase2_productivas : '')
      this.form.controls['clase2_infraestructura'].setValue(this.rows[0] ? this.rows[0].clase2_infraestructura : '')
      this.form.controls['clase2_areaVerde'].setValue(this.rows[0] ? this.rows[0].clase2_areaVerde : '')
      this.form.controls['clase2_espacioPublica'].setValue(this.rows[0] ? this.rows[0].clase2_espacioPublica : '')

      this.form.controls['actividad_equipamiento'].setValue(this.rows[0] ? this.rows[0].actividad_equipamiento : '')
      this.form.controls['actividad1_equipamiento'].setValue(this.rows[0] ? this.rows[0].actividad1_equipamiento : '')
      this.form.controls['actividad2_equipamiento'].setValue(this.rows[0] ? this.rows[0].actividad2_equipamiento : '')

      this.form.controls['escala_equipamiento'].setValue(this.rows[0] ? this.rows[0].escala_equipamiento : '')
      this.form.controls['escala1_equipamiento'].setValue(this.rows[0] ? this.rows[0].escala1_equipamiento : '')
      this.form.controls['escala2_equipamiento'].setValue(this.rows[0] ? this.rows[0].escala2_equipamiento : '')


    }

  }

  add_uso_suelo() {
    localStorage.setItem("uso_suelo", JSON.stringify([]));
    this.actualRow = localStorage.getItem("uso_suelo");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      destino_original: this.form.value.destino_original,

      clase_residencial: this.form.value.clase_residencial,
      clase_equipamiento: this.form.value.clase_equipamiento,
      clase_productivas: this.form.value.clase_productivas,
      clase_infraestructura: this.form.value.clase_infraestructura,
      clase_areaVerde: this.form.value.clase_areaVerde,
      clase_espacioPublica: this.form.value.clase_espacioPublica,

      clase1_residencial: this.form.value.clase1_residencial,
      clase1_equipamiento: this.form.value.clase1_equipamiento,
      clase1_productivas: this.form.value.clase1_productivas,
      clase1_infraestructura: this.form.value.clase1_infraestructura,
      clase1_areaVerde: this.form.value.clase1_areaVerde,
      clase1_espacioPublica: this.form.value.clase1_espacioPublica,

      clase2_residencial: this.form.value.clase2_residencial,
      clase2_equipamiento: this.form.value.clase2_equipamiento,
      clase2_productivas: this.form.value.clase2_productivas,
      clase2_infraestructura: this.form.value.clase2_infraestructura,
      clase2_areaVerde: this.form.value.clase2_areaVerde,
      clase2_espacioPublica: this.form.value.clase2_espacioPublica,

      actividad_equipamiento: this.form.value.actividad_equipamiento,
      actividad1_equipamiento: this.form.value.actividad1_equipamiento,
      actividad2_equipamiento: this.form.value.actividad2_equipamiento,

      escala_equipamiento: this.form.value.escala_equipamiento,
      escala1_equipamiento: this.form.value.escala1_equipamiento,
      escala2_equipamiento: this.form.value.escala2_equipamiento,

    })
    localStorage.setItem("uso_suelo", JSON.stringify(this.rows));
  }

  delete_normas(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("uso_suelo", JSON.stringify(this.rows));
      }
    }
  }

}
